export default __webpack_public_path__ + "static/media/Arabic.76ae24ce.png";